<template>
  <validation-observer
      ref="saveFormRef"
      #default="{invalid}"
  >
    <b-modal
        id="credentialSaveModal"
        body-class="position-static"
        centered
        :title="isCreated ? 'Thêm mới dữ liệu' : 'Cập nhật dữ liệu'"
        no-close-on-backdrop
        @show="onShow"
        @hidden="onHide"
    >
      <b-form>
        <b-form-group label-for="name">
          <template v-slot:label>
            Tên loại văn bằng/chứng chỉ <span class="text-danger">*</span>
          </template>
          <validation-provider
              #default="{errors}"
              name="Tên loại văn bằng/chứng chỉ"
              rules="required"
              s
          >
            <b-form-input
                id="name"
                v-model="targetItem.name"
                placeholder="Nhập tên loại văn bằng/chứng chỉ"
                :state="getElementState"
            >
              <small class="text-danger"> {{ errors[0] }}</small>
            </b-form-input>
          </validation-provider>
        </b-form-group>

        <b-form-group label-for="description">
          <template v-slot:label>
            Mô tả loại văn bằng/chứng chỉ <span class="text-danger">*</span>
          </template>
          <validation-provider
              #default="{errors}"
              name="Mô tả loại văn bằng/chứng chỉ"
              rules="required"
          >
            <b-form-input
                id="description"
                v-model="targetItem.description"
                placeholder="Nhập mô tả loại văn bằng/chứng chỉ"
                :state="getElementState"
            >
              <small class="text-danger"> {{ errors[0] }}</small>
            </b-form-input>
          </validation-provider>
        </b-form-group>

        <b-form-group label-for="type">
          <template v-slot:label>
            Phân loại <span class="text-danger">*</span>
          </template>
          <validation-provider
              #default="{ errors }"
              name="Phân loại"
              rules="required"
          >
            <v-select
                v-model="targetItem.credentialTypeId"
                :options="allCredentialTypes"
                :reduce="option => option.value"
            />
            <b-form-invalid-feedback :state="getElementState(errors)">
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>

        <b-form-group label-for="status">
          <template v-slot:label>
            Trạng thái <span class="text-danger">*</span>
          </template>
          <validation-provider
              #default="{ errors }"
              name="Trạng thái"
              rules="required"
          >
            <v-select
                v-model="targetItem.status"
                :options="statusOptions"
                :reduce="option => option.value"
            />
            <b-form-invalid-feedback :state="getElementState(errors)">
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>

      </b-form>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-1"
              :disabled="invalid"
              @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>

          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-secondary"
              @click="$bvModal.hide('credentialSaveModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </validation-observer>
</template>
<script>

import {
  BButton, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BModal, BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { getUser } from '@/auth/utils'
import vSelect from 'vue-select'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@vuelidate/validators'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'CredentialSave',
  components: {
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BOverlay,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      targetItem: {
        name: '',
        description: '',
        credentialTypeId: '',
        status: 1,
      },
      required,
    }
  },
  computed: {
    ...mapGetters({
      statuses: 'credential/statuses',
      allCredentialTypes: 'dropdown/allCredentialTypes',
    }),
    isCreated() {
      return !this.item
    },
    statusOptions() {
      return this.statuses
    },
  },
  methods: {
    ...mapActions({
      getAllCredentialTypes: 'dropdown/getAllCredentialTypes',
      createCredential: 'credential/createCredential',
      updateCredential: 'credential/updateCredential',
    }),
    async onShow() {
      await this.getAllCredentialTypes()
      if (this.item) {
        this.targetItem = { ...this.item }
      }
    },
    onHide() {
      this.targetItem = {
        name: '',
        description: '',
        type: '',
        status: 1,
      }
    },
    getElementState(errors) {
      return !(errors.length > 0)
    },
    async onSave(type = null) {
      const valid = this.$refs
        .saveFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = this.isCreated
            ? await this.createCredential(this.targetItem)
            : await this.updateCredential(this.targetItem)
          if (response) {
            const { isSuccessful, message } = response
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              if (type === 'hide') {
                this.$bvModal.hide('credentialSaveModal')
              }
              this.$emit('succeed')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      }
    },
  },

}
</script>
<style scoped lang="scss">
</style>
